/** Icons the workspace's own controls share. The header's search and the
 *  Create menu were removed (Tamar, 2026-10-28): the date takes the
 *  search's place, and each item is created on its own page. */
export function ActionIcon({ kind }: { kind: 'search' | 'plus' | 'chevron' | 'chart' | 'formula' | 'alarm' | 'close' | 'sensor' | 'arrow' | 'layout' | 'pencil' }) {
  const paths = {
    search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0', plus: 'M12 5v14M5 12h14',
    chevron: 'm7 10 5 5 5-5', chart: 'M3 3v18h18M6 15l4-5 4 3 6-7',
    formula: 'M7 21c4 0 1-18 6-18h4M6 9h11', alarm: 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
    close: 'm6 6 12 12M6 18 18 6', sensor: 'M7 7h10v10H7zM9 2v5m6-5v5M9 17v5m6-5v5M2 9h5m-5 6h5m10-6h5m-5 6h5',
    arrow: 'M5 12h14m-6-6 6 6-6 6', layout: 'M3 3h18v18H3zM3 8h18M15 8v13', pencil: 'M4 20h4L19 9l-4-4L4 16zM13 7l4 4',
  }
  return <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[kind]} /></svg>
}
